<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2" color="primary">mdi-link</v-icon>
        Link
      </v-card-title>
      <v-card-text>
        This link can be shared with a customer.
        <br />
        The link will be expired in
        <strong>7 days</strong>
        .
        <br />
        <br />
        <a :href="link" target="_blank">
          {{ link }}
        </a>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      link: ''
    };
  },
  methods: {
    open(link) {
      this.link = link;
      console.log('RES:', link);

      this.$copyText(this.link)
        .then(() =>
          this.$notify({
            type: 'success',
            title: 'Done',
            text: 'Link copied to clipboard'
          })
        )
        .then(() => (this.dialog = true));
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
